<template>
  <div class="main--text mb-4">
    <MoreTyme :key="`widgetmoretyme`" v-if="data.type === 'moretyme'" />
    <Payflex :key="`widgetpayflex`" v-if="data.type === 'payflex'" />
  </div>
</template>

<script>
import MoreTyme from "@/components/widgets/MoreTyme.vue";
import Payflex from "@/components/widgets/Payflex.vue";

export default {
  name: "WidgetTemplate",
  props: {
    data: Object,
  },
  components: {
    MoreTyme,
    Payflex,
  },
};
</script>

<style scoped></style>
